import React from 'react';
import { Link } from 'react-router-dom';

function Unauthorise() {


    return (
      <div className="" style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh'}}>
        <h3>
         <span className="fa fa-hand-stop-o" style={{color:'black'}}/>&nbsp;You are not authorized to access this page. Return to <Link to='/'>Dashboard</Link>

        </h3>
      </div>
    );
  }

  export default Unauthorise;
